import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import styles from './styles';

const useStyles = makeStyles(styles);

// Outlined action button used in form-action rows (inline sub-forms,
// modals, drawers). Default state: transparent background, colored
// border + text. Hover/focus inverts to filled background + white text.
// Two color variants are intentional and exhaustive: `primary` is the
// affirmative action (Save/Apply/Confirm) and `secondary` is the
// passive companion (Cancel/Discard). For richer surfaces, extend with
// a new color slot rather than adding boolean flags — see lib/README.md §8.
const FormActionButton = ({
  children,
  color,
  size,
  onClick,
  type,
  disabled,
  className,
  leadingIcon,
  trailingIcon,
}) => {
  const classes = useStyles();
  return (
    <MuiButton
      variant="outlined"
      onClick={onClick}
      type={type}
      disabled={disabled}
      disableRipple
      disableFocusRipple
      startIcon={leadingIcon}
      endIcon={trailingIcon}
      className={classnames(
        classes.root,
        size === 'small' && classes.sizeSmall,
        color === 'primary' && classes.colorPrimary,
        color === 'secondary' && classes.colorSecondary,
        className,
      )}
    >
      {children}
    </MuiButton>
  );
};

FormActionButton.propTypes = {
  children: propTypes.node.isRequired,
  color: propTypes.oneOf(['primary', 'secondary']),
  size: propTypes.oneOf(['small', 'medium']),
  onClick: propTypes.func,
  type: propTypes.oneOf(['button', 'submit', 'reset']),
  disabled: propTypes.bool,
  className: propTypes.string,
  leadingIcon: propTypes.node,
  trailingIcon: propTypes.node,
};

FormActionButton.defaultProps = {
  color: 'primary',
  size: 'medium',
  onClick: undefined,
  type: 'button',
  disabled: false,
  className: undefined,
  leadingIcon: undefined,
  trailingIcon: undefined,
};

export default FormActionButton;
